import React from 'react';

import BatchRequestUpload from 'components/LM/Voice/NewMassImport/Upload';
import DetailStatus from 'components/LM/Voice/NewMassImport/status/DetailStatus';
import OverallStatus from 'components/LM/Voice/NewMassImport/status/OverallStatus';
import BssoPermissions from "components/LM/Bsso/Permissions";

function NewMassImportView(props) {
	return (<BssoPermissions permissions={['voices']} behaviour="error">
		<BatchRequestLoader {...props} />
	</BssoPermissions>)
}

function BatchRequestLoader(props) {
	const locationPathname = props.location.pathname;
	if (locationPathname === "/voices/new-import") return <BatchRequestUpload {...props} />

	if (props.match.params.identifier) return <DetailStatus id={props.match.params.identifier} {...props} />;
	return <OverallStatus {...props} />;
}

export default NewMassImportView;
